// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panelHr {
  margin-bottom: 10px;
}

.jobTalentsData {
  width: 100%;
}

.jobTalentsData td:first-child {
  width: 38px;
}

.talentStatus {
  padding: 5px 0 5px 10px;
  font-size: 1.1rem;
}

.jobTalentsData .dropdown {
  color: #888;
  cursor: pointer;
}

.darkBg {
  background-color: #dfdfdf;
}

.semiBold {
  font-size: 1rem;
}

.yellowTalent {
  color: #efce7c;
}

.greenTalent {
  color: #78c7af;
}

#innerTextServer {
  width: 100%;
  border: 1px solid #BBB;
  padding: 10px;
  height: 200px;
  overflow-y: scroll;
}

.talentBox {
  height: 95px;
}

.aptitudeTitle {
  height: 30px;
  font-size: 130%;
}

.talentBox div:first-child, .talentBox div:nth-child(2) {
  margin-right: 5px;
}

.talentGraph {
  margin-right: 0;
}

/* Dropdown Button */
.dropbtn {
  text-align: right;
  padding: 0 5px 0 5px;
  border: none;
  min-width: 145px;
}

.dropbtnSmall {
  width: 160px;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  right: -3px;
  z-index: 1;
  background-color: white;
  min-width: 160px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

/* Show the dropdown menu on hover */
.show {
  display: block;
}

div.surfInPage div {
  width: 100%;
  padding: 5px;
}

::ng-deep .talentStatus div {
  float: none !important;
  display: inline-block;
  margin-left: 0 !important;
}

::ng-deep .talentStatus .clearfix {
  display: none;
}

.jobsCompetencesFooter button:first-child {
  margin-right: 10px;
}

::ng-deep .jobsCompetencesHeader .mat-grid-tile .mat-figure {
  align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/mobile/mobile-jobs-competences/mobile-jobs-competences.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA,oBAAA;AACA;EACI,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;AACJ;;AAEA,oCAAA;AACA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,sBAAA;EACA,qBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ","sourcesContent":[".panelHr {\n    margin-bottom: 10px;\n}\n\n.jobTalentsData {\n    width: 100%;\n}\n\n.jobTalentsData td:first-child {\n    width: 38px;\n}\n\n.talentStatus {\n    padding: 5px 0 5px 10px;\n    font-size: 1.1rem;\n}\n\n.jobTalentsData .dropdown {\n    color: #888;\n    cursor: pointer;\n}\n\n.darkBg {\n    background-color: #dfdfdf;\n}\n\n.semiBold {\n    font-size: 1rem;\n}\n\n.yellowTalent{\n    color: #efce7c\n}\n\n.greenTalent{\n    color: #78c7af\n}\n\n#innerTextServer {\n    width: 100%;\n    border: 1px solid #BBB;\n    padding: 10px;\n    height: 200px;\n    overflow-y: scroll;\n}\n\n.talentBox {\n    height: 95px;\n}\n\n.aptitudeTitle {\n    height: 30px;\n    font-size: 130%;\n}\n\n.talentBox div:first-child, .talentBox div:nth-child(2) {\n    margin-right: 5px;\n}\n\n.talentGraph  {\n    margin-right: 0;\n}\n\n/* Dropdown Button */\n.dropbtn {\n    text-align: right;\n    padding: 0 5px 0 5px;\n    border: none;\n    min-width: 145px;\n}\n\n.dropbtnSmall {\n    width: 160px\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    right: -3px;\n    z-index: 1;\n    background-color: white;\n    min-width: 160px;\n    box-shadow: 0 3px 4px 0 rgba(0,0,0,0.2);\n    cursor: pointer;\n}\n\n/* Show the dropdown menu on hover */\n.show {\n    display: block;\n}\n\ndiv.surfInPage div {\n    width: 100%;\n    padding: 5px;\n}\n\n::ng-deep .talentStatus div {\n    float: none !important;\n    display: inline-block;\n    margin-left: 0 !important;\n}\n\n::ng-deep .talentStatus .clearfix {\n    display: none;\n}\n\n.jobsCompetencesFooter button:first-child {\n    margin-right: 10px;\n}\n\n::ng-deep .jobsCompetencesHeader .mat-grid-tile .mat-figure {\n    align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
